import { render } from "./memberList.vue?vue&type=template&id=70927afe"
import script from "./memberList.vue?vue&type=script&lang=js"
export * from "./memberList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__